import BaseService from "./base.service";

export default class RecruitmentService extends BaseService {

    constructor(ctx) {
        super(ctx)
    }

    /**
     * Lấy danh sách vị trí tuyển dụng
     * @param {Object} query - { pageIndex, pageSize, keyword, locale, business_id, department_id, position_id, employment_type }
     * @returns {Promise}
     */
    getRecruitmentList = (query) => {
        return this.get('/recruitment', query);
    }

    /**
     * Lấy chi tiết 1 vị trí tuyển dụng theo ID
     * @param {Number} recruitment_id - ID vị trí tuyển dụng
     * @param {Object} query - { locale }
     * @returns {Promise}
     */
    getRecruitmentById = (recruitment_id, query) => {
        return this.get(`/recruitment/${recruitment_id}`, query)
    }

    /**
     * Lấy danh sách vị trí tuyển dụng theo business_id
     * @param {Number} business_id - ID bệnh viện/cơ sở
     * @param {Object} query - { pageIndex, pageSize, locale }
     * @returns {Promise}
     */
    getRecruitmentByBusiness = (business_id, query) => {
        return this.get(`/recruitment/by-business/${business_id}`, query);
    }

    /**
     * Lấy danh sách vị trí tuyển dụng theo department_id
     * @param {Number} department_id - ID khoa/phòng ban
     * @param {Object} query - { pageIndex, pageSize, locale }
     * @returns {Promise}
     */
    getRecruitmentByDepartment = (department_id, query) => {
        return this.get(`/recruitment/by-department/${department_id}`, query);
    }

    /**
     * Submit recruitment application với CV upload
     * @param {FormData} formData - FormData chứa thông tin ứng viên và file CV
     * @returns {Promise}
     */
    submitApplication = (formData) => {
        return this.postFormData('/recruitment/apply', formData);
    }

}

